import React from 'react';

interface Props {
  status: string;
}

/** Preset / test-run status pill; colours keyed by status name in entervice.scss. */
const StatusChip: React.FC<Props> = ({ status }) => (
  <span className={`ev-chip ev-chip--${status}`}>{status}</span>
);

export default StatusChip;
